const e = {
  name: "Restricted",
  dimensions: { width: 22, height: 22 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 12H9V15C9 15.5523 8.55229 16 8 16C7.44772 16 7 15.5523 7 15V7C7 6.44772 7.44772 6 8 6H12C13.6523 6 15 7.34772 15 9C15 10.3401 14.1135 11.4798 12.897 11.8627L14.8 14.4C15.1314 14.8418 15.0418 15.4686 14.6 15.8C14.1582 16.1314 13.5314 16.0418 13.2 15.6L10.5 12ZM9 10V8H12C12.5477 8 13 8.45228 13 9C13 9.54772 12.5477 10 12 10H11.0103C11.0029 9.99992 10.9955 9.99992 10.9881 10H9Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11Z" />
    </svg>
  `
};
export {
  e as Restricted
};
